
import { Injectable, inject } from '@angular/core';
import { Firestore, collection, writeBatch, doc, getDocs, collectionData } from '@angular/fire/firestore';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  private firestore: Firestore = inject(Firestore);

  async initializeCountries(countries: { name: string; code: string }[]): Promise<void> {
    const batch = writeBatch(this.firestore);
    const countriesCol = collection(this.firestore, 'countries');
    const snapshot = await getDocs(countriesCol);
    
    const existingMap = new Map<string, any>();
    snapshot.docs.forEach(doc => existingMap.set(doc.data()['name'], doc.ref));
    
    let hasUpdates = false;

    for (const country of countries) {
      if (existingMap.has(country.name)) {
        const ref = existingMap.get(country.name);
        batch.update(ref, { code: country.code, updatedAt: new Date() });
        hasUpdates = true;
      } else {
        // Create document with auto-generated unique ID
        const ref = doc(countriesCol);
        batch.set(ref, { name: country.name, code: country.code, isActive: true, updatedAt: new Date() });
        hasUpdates = true;
      }
    }

    if (hasUpdates) {
      await batch.commit();
    }
  }

  getCountries(): Observable<any[]> {
    const countriesCol = collection(this.firestore, 'countries');
    return collectionData(countriesCol, { idField: 'id' });
  }
}